/* eslint-disable */
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Container, Stack, TextField, FormControl, Grid, Button, Chip,
  Paper, InputLabel, Checkbox, FormHelperText, IconButton, Typography
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Page from '../../../Page';
import { AESEncryptionParam, AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import services from '../Service';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import ImageUploader from 'react-images-upload';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import permissionAuth from 'src/utils/permissionAuth';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Icon from '@material-ui/core/Icon';

export default function ProductAddEdit(props) {
  const screenCode = 'PRODUCT';
  const navigate = useNavigate();
  const { productID } = useParams();
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Save",
    pageheadername: "Add Product "
  });

  const [productcatogery, setProductcatogery] = useState([]);
  const [productSubcatogery, setProductSubcatogery] = useState([]);
  const [specialProductcatogery, setSpecialProductcatogery] = useState([]);
  const [productVarietySelect, setProductVarietySelect] = useState([]);
  const [ImageHide, setImageHide] = useState(true);
  const [ImageObject, setImageObject] = useState();
  const [productVariety, setProductVariety] = useState([]);
  const [productVarietyForUpdate, setProductVarietyForUpdate] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [canEditProductCode, setCanEditProductCode] = useState(false);
  const [bomEnabled, setBomEnabled] = useState(false);
  const [cutSkuEnabled, setCutSkuEnabled] = useState(false);
  const [originalBomMode, setOriginalBomMode] = useState({ bomEnabled: false, cutSkuEnabled: false });
  const [originalBomRows, setOriginalBomRows] = useState([]);
  const [deletedBomMappingIds, setDeletedBomMappingIds] = useState([]);
  const [skuMasterList, setSkuMasterList] = useState([]);
  const [bomRows, setBomRows] = useState([]);
  const [editingBomRow, setEditingBomRow] = useState(null);
  const [deleteBomConfirm, setDeleteBomConfirm] = useState({ open: false, row: null });
  const [backConfirmOpen, setBackConfirmOpen] = useState(false);
  const [bomLineForm, setBomLineForm] = useState({
    skuCode: '',
    quantity: ''
  });
  const [bomLineErrors, setBomLineErrors] = useState({ skuCode: '', name: '', uom: '', quantity: '' });
  const [editingBomSkuCode, setEditingBomSkuCode] = useState('');
  const [formData, setFormData] = useState({
    productCategoryID: "0",
    specialProductCategoryID: "0",
    productCode: "",
    productName: "",
    measuringUnitID: "0",
    productVarietyID: "",
    productDescription: "",
    offValue: "",
    offValueTypeID: "0",
    measuringGram: "0",
    image: "",
    isActive: true,
    isSeasonal: false
  });

  useEffect(() => {
    getPermissions();
  }, []);


  useEffect(() => {
    setValues((prevState) => ({
      ...prevState,
      productSubCategoryID: selectedOptions,
    }));
  }, [selectedOptions]);


  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITPRODUCT');
    var editCodePermission = permissions.find(p => p.permissionCode == 'EDITPRODUCTCODE');
    setCanEditProductCode(editCodePermission !== undefined);

    if (isAuthorized === undefined) {
      navigate('/404');
    }
  }

  const ProductSaveSchema = Yup.object().shape({
    productCategoryID: Yup.number()
      .min(1, 'Please Select Product Category')
      .required('Product Category Required'),
    productSubCategoryID: Yup.array()
      .min(1, 'Please Select Product Sub Category')
      .required('Product Sub Category Required'),
    productCode: Yup.string().matches(/^\S+$/, 'Product Code Required and cannot contain spaces')
      .required('Product Code Required'),
    productName: Yup.string().matches(/^(|[^\s].*[^\s]|[^\s])$/, 'Product Name Required and cannot contain spaces')
      .required('Product Name Required'),
    measuringUnitID: Yup.string(),
    productVarietyID: Yup.string(),
    productDescription: Yup.string(),
    offValue: Yup.number()
      .transform((value, originalValue) => (originalValue === '' ? undefined : value))
      .typeError('Off Value must be a number')
      .test('off-value-decimal-places', 'Off Value can have up to 3 decimal places', function (value) {
        const { originalValue } = this;
        if (originalValue === '' || originalValue === undefined || originalValue === null || value === undefined || value === null) {
          return true;
        }
        return /^\d*\.?\d{0,3}$/.test(String(originalValue));
      })
      .when('offValueTypeID', {
        is: (value) => Number(value) === 2,
        then: (schema) => schema.max(100, 'Percentage Off Value must be less than or equal to 100'),
      }),
    measuringUnitID: Yup.number()
      .min(1, 'Please Select Measuring Unit')
      .required('Measuring Unit Required'),
  });

  const formik = useFormik({
    initialValues: {
      productCategoryID: formData.productCategoryID,
      productSubCategoryID: selectedOptions,
      specialProductCategoryID: formData.specialProductCategoryID,
      productCode: formData.productCode,
      productName: formData.productName,
      measuringUnitID: formData.measuringUnitID,
      productDescription: formData.productDescription,
      offValue: formData.offValue,
      offValueTypeID: formData.offValueTypeID,
      productVarietyID: formData.productVarietyID,
      measuringGram: formData.measuringGram,
      image: formData.image,
      isActive: formData.isActive,
      isSeasonal: formData.isSeasonal
    },
    validationSchema: ProductSaveSchema,
    onSubmit: (values) => {
      if (pageProps.editingID > 0) {
        trackPromise(UpdateProduct(values, ImageObject, pageProps.editingID));
      } else {
        trackPromise(SaveProduct(values, ImageObject));
      }
    },
  });

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  const handleOffValueChange = (event) => {
    const { value } = event.target;
    if (value !== '' && !/^\d*\.?\d{0,3}$/.test(value)) {
      return;
    }
    formik.handleChange(event);
  };

  useEffect(() => {
    if (pageProps.isEdit == false) {
      setValues((prevState) => ({
        ...prevState,
        offValue: "",
      }));
    }
  }, [formik.values.offValueTypeID]);

  const toBomPayload = (row, isActive) => ({
    productBomMappingID: Number(row.productBomMappingID || 0),
    skuCode: row.skuCode,
    quantity: row.quantity,
    measuringUnitID: row.measuringUnitID,
    bomProductID: Number(row.bomProductID),
    productCodeID: Number(row.productCodeID || 0),
    isActive: isActive
  });

  async function SaveProduct(values, image) {
    if ((bomEnabled || cutSkuEnabled) && bomRows.length === 0) {
      toast.error(cutSkuEnabled ? 'Please select Cut SKU' : 'Please add at least one BOM line');
      return;
    }

    const isBOMEnabledForSubmit = bomEnabled;
    const billOfMaterialsForSubmit = cutSkuEnabled
      ? bomRows.slice(0, 1).map((x) => ({ ...x, quantity: 0 }))
      : bomRows;

    if (productVariety.length > 0) {
      const res = await services.SaveProduct(
        values,
        image,
        productVariety,
        selectedOptions,
        isBOMEnabledForSubmit,
        billOfMaterialsForSubmit,
        cutSkuEnabled
      );
      if (res.statusCode === "Success") {
        toast.success("Product Saved Successfully");
        navigate('/dashboard/product/listing');
      } else {
        toast.error(res.message);
      }
    } else {
      toast.error("Add Product Variety");
    }
  }

  async function UpdateProduct(values, image, productID) {
    if ((bomEnabled || cutSkuEnabled) && bomRows.length === 0) {
      toast.error(cutSkuEnabled ? 'Please select Cut SKU' : 'Please add at least one BOM line');
      return;
    }

    const isBomOrCutEnabled = bomEnabled || cutSkuEnabled;
    const modeChanged =
      (originalBomMode && originalBomMode.bomEnabled !== bomEnabled) ||
      (originalBomMode && originalBomMode.cutSkuEnabled !== cutSkuEnabled);

    if (!isBomOrCutEnabled) {
      const sourceRows = (originalBomRows && originalBomRows.length > 0) ? originalBomRows : bomRows;
      const deletedIds = (sourceRows || [])
        .map((x) => Number(x.productBomMappingID || 0))
        .filter((id) => id > 0);

      if (productVarietyForUpdate.length > 0 || productVariety.length > 0) {
        const res = await services.UpdateProduct(
          values,
          image,
          productVarietyForUpdate,
          productID,
          productVariety,
          selectedOptions,
          false,
          [],
          false,
          deletedIds
        );
        if (res.statusCode === "Success") {
          toast.success("Product Updated Successfully");
          navigate('/dashboard/product/listing');
        } else {
          toast.error(res.message);
        }
      } else {
        toast.error("Add Product Variety");
      }
      return;
    }

    const isBOMEnabledForSubmit = bomEnabled;
    const activeLines = cutSkuEnabled
      ? bomRows.slice(0, 1).map((x) => ({ ...x, quantity: 0 }))
      : bomRows;

    const activePayload = (activeLines || []).map((x) => toBomPayload(x, true));
    const activeMappingIds = new Set(
      (activeLines || [])
        .map((x) => Number(x.productBomMappingID || 0))
        .filter((id) => id > 0)
    );

    const removedFromOriginalIds = (originalBomRows || [])
      .map((x) => Number(x.productBomMappingID || 0))
      .filter((id) => id > 0)
      .filter((id) => !activeMappingIds.has(id));

    const deletedIds = Array.from(
      new Set([...(deletedBomMappingIds || []), ...removedFromOriginalIds])
    ).filter((id) => Number(id) > 0);

    const billOfMaterialsForSubmit = activePayload;

    if (productVarietyForUpdate.length > 0 || productVariety.length > 0) {
      const res = await services.UpdateProduct(
        values,
        image,
        productVarietyForUpdate,
        productID,
        productVariety,
        selectedOptions,
        isBOMEnabledForSubmit,
        billOfMaterialsForSubmit,
        cutSkuEnabled,
        deletedIds
      );
      if (res.statusCode === "Success") {
        toast.success("Product Updated Successfully");
        navigate('/dashboard/product/listing');
      } else {
        toast.error(res.message);
      }
    } else {
      toast.error("Add Product Variety");
    }
  }

  let decrypted = 0;
  useEffect(() => {
    decrypted = AESDecryptionParam(productID);
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEdit: true,
        submitButtonName: "Update",
        pageheadername: "Update Product ",
        editingID: parseInt(decrypted)
      })
      trackPromise(getproduct(parseInt(decrypted)))
    }
    trackPromise(GetProductCategoties(), GetProductSubCategoties());
    trackPromise(GetSpecialProductCategoties());
    trackPromise(GetAllProductVariety(parseInt(decrypted)));
    trackPromise(GetAllProductsForBOM(parseInt(decrypted)));
  }, []);

  async function GetProductCategoties() {
    var res = await services.GetProductCategotiesForDropDown()
    if (res != null) {
      setProductcatogery(res);
    }
  }

  async function GetProductSubCategoties() {
    var res = await services.GetProductSubCategotiesForDropDown()
    if (res != null) {
      var newOptionArray = [];
      for (var i = 0; i < res.length; i++) {
        newOptionArray.push({ label: res[i].productSubCategoryName, value: res[i].productSubCategoryID })
      }
      setProductSubcatogery(newOptionArray);
    }
  }

  async function GetSpecialProductCategoties() {
    var res = await services.GetSpecialProductCategotiesForDropDown()
    if (res != null) {
      setSpecialProductcatogery(res);
    }
  }

  async function GetAllProductsForBOM(excludeProductID = 0) {
    var res = await services.GetAllProductsForBOMDropDown(excludeProductID);
    if (res != null) {
      const getUOM = (val) => {
        if (val == 1) return 'Unit';
        if (val == 2) return 'Kg';
        if (val == 3) return 'g';
        return val;
      };
      const mappedSkuList = res.map((x) => ({
        skuCode: x.skuCode || x.productCode || '',
        name: x.skuDescription || x.productName || '',
        uom: getUOM(x.uom || x.measuringUnitName || x.measuringUnit || x.measuringUnitID || ''),
        measuringUnitID: x.measuringUnitID || x.uom || x.measuringUnitName || x.measuringUnit || 0,
        productID: x.productID,
        isBOM: x.isBOM || false,
        isCutSKU: x.isCutSKU || false
      })).filter((x) => x.skuCode !== '');
      setSkuMasterList(mappedSkuList);
    }
  }

  async function getproduct(productID) {
    var product = await services.GetProductDetailsByProductID(productID)
    setValues((prevState) => ({
      ...prevState,
      productCategoryID: product.productCategoryID,
      specialProductCategoryID: product.specialProductCategoryID,
      productCode: product.productCode,
      productName: product.productName,
      productTypeID: 0,
      productDescription: product.productDescription == null ? '' : product.productDescription,
      offValue: product.offValue == null ? '' : product.offValue,
      offValueTypeID: product.offValueTypeID || "0",
      isActive: product.isActive,
      isSeasonal: product.isSeasonal,
      image: product.image,
      measuringUnitID: product.measuringUnit,
      measuringGram: product.measuringGram
    }));
    let result = [];
    product.productSubCategories.forEach(x => {
      result.push(x.productSubCategoryID)
    })
    setSelectedOptions(result)
    setImageObject(product.image)
    setFormData(product)
    setImageHide(product.image == null ? true : false)

    const productBOM = product.billOfMaterials || product.bomLines || product.bom || [];
    const isCutSkuFromApi =
      product.isCutSKUEnabled === true ||
      product.isCutSkuEnabled === true ||
      product.isCutSKU === true ||
      product.isCutSku === true;

    if (isCutSkuFromApi) {
      setCutSkuEnabled(true);
      setBomEnabled(false);
      setOriginalBomMode({ bomEnabled: false, cutSkuEnabled: true });
    } else {
      setCutSkuEnabled(false);
      const initialBomEnabled = product.isBOMEnabled === true || productBOM.length > 0;
      setBomEnabled(initialBomEnabled);
      setOriginalBomMode({ bomEnabled: initialBomEnabled, cutSkuEnabled: false });
    }
    if (productBOM.length > 0) {
      const getUOM = (val) => {
        if (val == 1) return 'Unit';
        if (val == 2) return 'Kg';
        if (val == 3) return 'g';
        return val;
      };
      const mapped = productBOM.map((x, idx) => ({
        productBomMappingID: Number(x.productBomMappingID || x.productBomMappingId || x.id || 0),
        skuCode: x.skuCode || x.productCode || '',
        name: x.name || x.productName || x.skuDescription || '',
        uom: getUOM(x.uom || x.measuringUnitName || x.measuringUnit || x.measuringUnitID || ''),
        measuringUnitID: x.measuringUnitID || x.uom || x.measuringUnitName || x.measuringUnit || 0,
        quantity: parseFloat(x.quantity || x.Quantity || x.componentQuantity || x.qty || 0) || 0,
        bomProductID: Number(x.bomProductID),
        productCodeID: Number(x.productCodeID || x.productCodeId || x.componentProductID || x.productID || x.productId || 0),
        isActive: (x.isActive ?? x.IsActive ?? true),
        tempId: x.productBomMappingID || x.productBomMappingId || x.id || `existing-${idx}-${Date.now()}`
      }));
      setBomRows(mapped);
      setOriginalBomRows(mapped);
      setDeletedBomMappingIds([]);
    } else {
      setBomRows([]);
      setOriginalBomRows([]);
      setDeletedBomMappingIds([]);
    }
  }

  const selectedBomSku = skuMasterList.find((item) => item.skuCode === bomLineForm.skuCode);

  const handleBomLineChange = (event) => {
    const { name, value } = event.target;
    if (name === 'quantity' && value !== '' && !/^\d*\.?\d{0,3}$/.test(value)) {
      return;
    }
    setBomLineErrors((prev) => ({
      ...prev,
      [name === 'skuCode' ? 'skuCode' : name]: '',
      ...(name === 'skuCode' ? { name: '', uom: '' } : {})
    }));
    setBomLineForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddBomLine = () => {
    const isCutSkuMode = cutSkuEnabled === true;
    const errors = { skuCode: '', name: '', uom: '', quantity: '' };

    if (!bomLineForm.skuCode) {
      errors.skuCode = 'Please select a Product Code';
      errors.name = 'Please select a Product Name';
      errors.uom = 'Please select a UOM';
    }

    const selectedSku = skuMasterList.find((x) => x.skuCode === bomLineForm.skuCode);
    if (bomLineForm.skuCode && !selectedSku) {
      errors.skuCode = 'Selected SKU is not available in Product Master';
      errors.name = 'Selected SKU is not available in Product Master';
      errors.uom = 'Selected SKU is not available in Product Master';
    }

    let quantity = null;
    if (!isCutSkuMode) {
      quantity = parseFloat(bomLineForm.quantity);
      if (Number.isNaN(quantity) || quantity <= 0) {
        errors.quantity = 'Please enter a valid quantity greater than zero';
      }
    }

    if (!isCutSkuMode) {
      const isDuplicate = bomRows.some((x) => x.skuCode === bomLineForm.skuCode && x.skuCode !== editingBomSkuCode);
      if (isDuplicate) {
        toast.error('Selected SKU is already added in BOM');
        return;
      }
    }

    const existingRow = isCutSkuMode
      ? (editingBomRow || (bomRows && bomRows.length > 0 ? bomRows[0] : null))
      : (editingBomSkuCode !== '' ? (editingBomRow || bomRows.find(x => x.skuCode === editingBomSkuCode)) : null);

    if (Object.values(errors).some((v) => v && v.length > 0)) {
      setBomLineErrors(errors);
      return;
    }

    const newBomLine = {
      productBomMappingID: Number(existingRow ? (existingRow.productBomMappingID || 0) : 0),
      skuCode: selectedSku.skuCode,
      name: selectedSku.name,
      uom: selectedSku.uom,
      measuringUnitID: selectedSku.measuringUnitID,
      quantity: quantity,
      bomProductID: Number(selectedSku.productID || 0),
      productCodeID: Number(selectedSku.productID || 0),
      tempId: existingRow && existingRow.tempId ? existingRow.tempId : `new-${Date.now()}-${Math.floor(Math.random() * 1000)}`
    };

    if (isCutSkuMode) {
      setBomRows([newBomLine]);
      setEditingBomSkuCode('');
      setEditingBomRow(null);
    } else {
      if (editingBomSkuCode !== '') {
        setBomRows((prev) => [{ ...newBomLine, tempId: (existingRow && existingRow.tempId) ? existingRow.tempId : newBomLine.tempId }, ...prev]);
        setEditingBomSkuCode('');
        setEditingBomRow(null);
      } else {
        setBomRows((prev) => [...prev, newBomLine]);
      }
    }

    setBomLineForm({
      skuCode: '',
      quantity: ''
    });
    setBomLineErrors({ skuCode: '', name: '', uom: '', quantity: '' });
  };

  const handleRemoveBomLine = (row) => {
    const skuCode = row.skuCode;

    if ((pageProps.editingID && pageProps.editingID > 0) && Number(row.productBomMappingID || 0) > 0) {
      const id = Number(row.productBomMappingID || 0);
      setDeletedBomMappingIds((prev) => Array.from(new Set([...(prev || []), id])));
    }

    setBomRows((prev) => prev.filter((x) => x.skuCode !== skuCode));
    if (editingBomSkuCode === skuCode) {
      setEditingBomSkuCode('');
      setBomLineForm({ skuCode: '', quantity: '' });
    }
  };

  const openDeleteBomConfirm = (row) => {
    setDeleteBomConfirm({ open: true, row: row || null });
  };

  const closeDeleteBomConfirm = () => {
    setDeleteBomConfirm({ open: false, row: null });
  };

  const confirmDeleteBomLine = async () => {
    const row = deleteBomConfirm.row;
    if (!row) {
      closeDeleteBomConfirm();
      return;
    }
    handleRemoveBomLine(row);
    closeDeleteBomConfirm();
  };

  const requestRemoveBomLine = (row) => {
    if (pageProps.editingID && pageProps.editingID > 0) {
      openDeleteBomConfirm(row);
      return;
    }
    handleRemoveBomLine(row);
  };

  const handleEditBomLine = (row) => {
    setBomLineErrors({ skuCode: '', name: '', uom: '', quantity: '' });
    setEditingBomSkuCode(row.skuCode);
    setEditingBomRow(row);
    setBomLineForm({
      skuCode: row.skuCode,
      quantity: row.quantity === null || row.quantity === undefined ? '' : row.quantity.toString()
    });

    setBomRows((prev) => prev.filter((x) => x.skuCode !== row.skuCode));
  };

  const handleCancelBomEdit = () => {
    if (editingBomRow) {
      setBomRows((prev) => [editingBomRow, ...prev]);
    }
    setEditingBomSkuCode('');
    setEditingBomRow(null);
    setBomLineErrors({ skuCode: '', name: '', uom: '', quantity: '' });
    setBomLineForm({ skuCode: '', quantity: '' });
  };

  async function GetAllProductVariety(productID) {
    var res = await services.GetAllProductVarietyByProductID(productID);
    if (res != null) {
      let temModel = {}
      res.forEach((x) => {
        temModel = {
          varietyName: x.varietyName,
          productVarietyID: x.productVarietyID
        }
        setProductVariety(productVariety => [...productVariety, temModel]);
        setProductVarietySelect(productVarietySelect => [...productVarietySelect, temModel]);
      })
    }
  }

  async function handleDelete(e) {
    const name = e.varietyName;
    const productVarietyID = e.productVarietyID;
    if (productVarietyID != undefined) {
      var availability = await services.CheckProductPlotAvailablility(productVarietyID);
      if (availability.length != 0) {
        toast.error("Variety Already Mapped to a Plot");
      }
      else {
        setProductVarietySelect(productVarietySelect.filter(item => item.varietyName !== name));
        var res = await services.DeleteProductVariety(productVarietyID, bomEnabled, cutSkuEnabled);
        if (res > 0) {
          toast.success("Product variety deleted succesfully");
        }
        else if (res == -1) {
          toast.error("Cannot update master data. Please delete today's existing customer order first.");
        }
        else {
          toast.error("Product variety not deleted");
        }
        setProductVariety(productVariety.filter(item => item !== name));
        if (pageProps.isEdit > 0) {
          setProductVarietyForUpdate(productVarietyForUpdate.filter(item => item.varietyName !== name));
        }
      }
    }
    else {
      setProductVarietySelect(productVarietySelect.filter(item => item.varietyName !== name));
    }
  };

  async function addItem() {
    if (formik.values.productVarietyID != "" && formik.values.productVarietyID !== undefined) {
      if (formik.values.productVarietyID.charAt(0) == " ") {
        toast.error("Can not add product variety with spaces.");
      }
      else {
        var alreadyAdded = false;
        productVariety.forEach((item) => {
          if (item.varietyName == formik.values.productVarietyID) {
            alreadyAdded = true;
          }
        })
        if (alreadyAdded) {
          toast.error("Can not duplicate product variety.");
        }
        else {
          let temModel = {
            varietyName: formik.values.productVarietyID
          }
          setProductVariety(productVariety => [...productVariety, temModel]);
          setProductVarietySelect(productVarietySelect => [...productVarietySelect, temModel]);
          if (pageProps.isEdit > 0) {
            setProductVarietyForUpdate(productVarietyForUpdate => [...productVarietyForUpdate, temModel]);
          }
          formik.values.productVarietyID = "";
        }
      }
    }
    else {
      toast.error("Please add product variety.");
    }
  }

  function onDrop(picture, imageUrl) {
    if (imageUrl.length === 0) {
      setImageHide(true)
      return
    }
    else {
      var convertedString = imageUrl[0];
      var fields = convertedString.split(",");
      setImageObject(fields[1]);
      setImageHide(false)
      setValues({
        ...values,
        image: fields[1]
      });
    }
  }

  function generateProductCategoryDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(x.isActive == true ? <MenuItem key={x.productCategoryID} value={x.productCategoryID}>{x.productCategoryName}</MenuItem> : null)
      });
    }
    return items
  }

  function generateSpecialProductCategoryDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(x.isActive == true ? <MenuItem key={x.specialProductCategoryID} value={x.specialProductCategoryID}>{x.specialProductCategoryName}</MenuItem> : null)
      });
    }
    return items
  }

  async function clearAll() {
    formik.resetForm();
    setProductVarietySelect([]);
    setImageObject();
    setImageHide(true)
    setBomEnabled(false);
    setCutSkuEnabled(false);
    setBomRows([]);
    setBomLineForm({ skuCode: '', quantity: '' });
    setBomLineErrors({ skuCode: '', name: '', uom: '', quantity: '' });

  }

  const handleClearSelection = () => {
    setSelectedOptions([]);
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    if (value.includes("")) {
      setSelectedOptions(selectedOptions.length === productSubcatogery.length ? [] : productSubcatogery.map((option) => option.value));
    } else {
      setSelectedOptions(value);
    }
  };

  const shouldConfirmOnBack = () => {
    const isEditing = Number(pageProps?.editingID || 0) > 0;
    const isOriginallyISBOMOrISCUT =
      (originalBomMode?.bomEnabled === true) ||
      (originalBomMode?.cutSkuEnabled === true);
    const isEditingBomOrCutLine = (editingBomSkuCode || '') !== '';

    return isEditing && isOriginallyISBOMOrISCUT && isEditingBomOrCutLine;
  };

  const handleBackClick = () => {
    if (shouldConfirmOnBack()) {
      setBackConfirmOpen(true);
      return;
    }
    navigate('/dashboard/product/listing');
  };

  const closeBackConfirm = () => {
    setBackConfirmOpen(false);
  };

  const confirmBackNavigation = () => {
    setBackConfirmOpen(false);
    navigate('/dashboard/product/listing');
  };

  const renderCategorySelectedValue = (selected) => {
    if (selected.length === 0) {
      return '';
    } else if (selected.length === 1) {
      const option = productSubcatogery.find((entity) => entity.value === selected[0]);
      return option ? option.label : '';
    } else {
      const selectedChips = selected.map((value, index) => {
        if (index === 0) {
          const option = productSubcatogery.find((entity) => entity.value === value);
          return option ? option.label : null;
        } else {
          const option = productSubcatogery.find((entity) => entity.value === value);
          return option ? option.label : null;
        }
      });
      const moreCount = selected.length - 1;
      return (
        <div>
          {selectedChips[0]} + {moreCount} more
        </div>
      );
    }
  };

  return (
    <>
      <LoadingComponent />
      <Page title="Add Product  |  FAPS">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography variant="h4" gutterBottom>
              {pageProps.pageheadername}
            </Typography>
            <Button
              variant="contained"
              to="#"
              color='secondary'
              onClick={handleBackClick}
              startIcon={<Icon>backspaceIcon</Icon>}
            >
              Back
            </Button>
          </Stack>
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Product Category *"
                    value={formik.values.productCategoryID}
                    onChange={formik.handleChange}
                    {...getFieldProps('productCategoryID')}
                    error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                    helperText={touched.productCategoryID && errors.productCategoryID}
                  >
                    <MenuItem key={0} value={0}> Select Product Category</MenuItem>
                    {generateProductCategoryDropDownMenu(productcatogery)}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Special Product Category"
                    value={formik.values.specialProductCategoryID}
                    onChange={formik.handleChange}
                    {...getFieldProps('specialProductCategoryID')}
                    error={Boolean(touched.specialProductCategoryID && errors.specialProductCategoryID)}
                    helperText={touched.specialProductCategoryID && errors.specialProductCategoryID}
                  >
                    <MenuItem key={0} value={0}> Select Special Product Category</MenuItem>
                    {generateSpecialProductCategoryDropDownMenu(specialProductcatogery)}
                  </TextField>
                  <FormControl fullWidth error={Boolean(touched.productSubCategoryID && errors.productSubCategoryID)}>
                    <InputLabel id="multi-select-label">Product Sub Category *</InputLabel>
                    <Select
                      className="custom-select"
                      labelId="multi-select-label"
                      id="multi-select"
                      multiple
                      size="small"
                      value={selectedOptions}
                      onChange={handleSelectChange}
                      label="Product Sub Category *"
                      renderValue={(selected) => renderCategorySelectedValue(selected)}
                    >
                      <MenuItem key={0} value={""}>
                        <Checkbox checked={selectedOptions.length === productSubcatogery.length} color="primary" />
                        All Product Sub Category
                      </MenuItem>
                      {productSubcatogery.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {touched.productSubCategoryID && errors.productSubCategoryID && (
                      <FormHelperText>{errors.productSubCategoryID}</FormHelperText>
                    )}
                    {selectedOptions.length > 0 && (
                      <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                        <ClearIcon />
                      </IconButton>
                    )}
                  </FormControl>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Product Code  *"
                      value={formik.values.productCode}
                      disabled={!canEditProductCode && pageProps.isEdit}
                      onChange={formik.handleChange}
                      {...getFieldProps('productCode')}
                      error={Boolean(touched.productCode && errors.productCode)}
                      helperText={touched.productCode && errors.productCode}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Product Name *"
                      value={formik.values.productName}
                      onChange={formik.handleChange}
                      {...getFieldProps('productName')}
                      error={Boolean(touched.productName && errors.productName)}
                      helperText={touched.productName && errors.productName}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <Grid item md={formik.values.measuringUnitID == 1 ? 6 : 12} xs={12}>
                        <TextField
                          select
                          fullWidth
                          size="small"
                          label="Measuring Unit *"
                          value={formik.values.measuringUnitID}
                          onChange={formik.handleChange}
                          {...getFieldProps('measuringUnitID')}
                          error={Boolean(touched.measuringUnitID && errors.measuringUnitID)}
                          helperText={touched.measuringUnitID && errors.measuringUnitID}
                        >
                          <MenuItem key={0} value={0}> Select Measuring Unit</MenuItem>
                          <MenuItem value={1}>Unit</MenuItem>
                          <MenuItem value={2}>Kg</MenuItem>
                          <MenuItem value={3}>g</MenuItem>
                        </TextField>
                      </Grid>
                      {formik.values.measuringUnitID == 1 ?
                        <Grid item md={6} xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Gram"
                            value={formik.values.measuringGram}
                            onChange={formik.handleChange}
                            {...getFieldProps('measuringGram')}
                            defaultValue={0}
                            onKeyDown={(evt) =>
                              (evt.key === "-") && evt.preventDefault()
                            }
                            InputProps={{
                              inputProps: {
                                step: 0.01,
                                type: 'number',
                                style: {
                                  textAlign: 'right',
                                },
                              },
                            }}
                            onWheel={event => event.target.blur()}
                          />
                        </Grid> : null}
                    </Stack>
                  </Grid>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Grid item md={4} xs={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Product Variety *"
                        value={formik.values.productVarietyID}
                        onChange={formik.handleChange}
                        {...getFieldProps('productVarietyID')}
                        error={Boolean(touched.productVarietyID && errors.productVarietyID)}
                        helperText={touched.productVarietyID && errors.productVarietyID}
                      />

                      <Button variant="contained" color='secondary' onClick={() => addItem()} >
                        Add
                      </Button>
                    </Stack>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Decription"
                      value={formik.values.productDescription}
                      onChange={formik.handleChange}
                      {...getFieldProps('productDescription')}
                      error={Boolean(touched.productDescription && errors.productDescription)}
                      helperText={touched.productDescription && errors.productDescription}
                    />
                  </Grid>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Stack width={375}>
                    <Paper style={{ marginTop: '3px', width: '100%' }}>
                      {productVarietySelect.map((product) => (
                        <Chip
                          style={{ margin: '2px' }}
                          label={product.varietyName}
                          onDelete={(e) => { handleDelete(product) }}
                          error={Boolean(touched.productVarietyID && errors.productVarietyID)}
                          helperText={touched.productVarietyID && errors.productVarietyID}
                        />))}
                    </Paper>
                  </Stack>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Off Value Type"
                      value={formik.values.offValueTypeID}
                      onChange={formik.handleChange}
                      {...getFieldProps('offValueTypeID')}
                      error={Boolean(touched.offValueTypeID && errors.offValueTypeID)}
                      helperText={touched.offValueTypeID && errors.offValueTypeID}
                    >
                      <MenuItem key={0} value={0}> Select Off Value Type</MenuItem>
                      <MenuItem value={1}>Flat Amount</MenuItem>
                      <MenuItem value={2}>Percentage</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Off Value"
                      value={formik.values.offValue}
                      {...getFieldProps('offValue')}
                      onChange={handleOffValueChange}
                      error={Boolean(touched.offValue && errors.offValue)}
                      helperText={touched.offValue && errors.offValue}
                      onKeyDown={(evt) => (evt.key === '-') && evt.preventDefault()}
                      InputProps={{
                        inputProps: {
                          step: 0.001,
                          min: 0,
                          max: formik.values.offValueTypeID == 2 ? 100 : undefined,
                          type: 'number'
                        }
                      }}
                      disabled={formik.values.offValueTypeID == 0}
                      onWheel={event => event.target.blur()}
                    />
                  </Grid>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={bomEnabled}
                        onChange={(event) => {
                          setBomEnabled(event.target.checked);
                          if (event.target.checked) {
                            setCutSkuEnabled(false);
                            setBomRows([]);
                            setBomLineForm({ skuCode: '', quantity: '' });
                            setEditingBomSkuCode('');
                            setEditingBomRow(null);
                          }
                          if (!event.target.checked) {
                            setBomRows([]);
                            setBomLineForm({ skuCode: '', quantity: '' });
                            setEditingBomSkuCode('');
                            setEditingBomRow(null);
                          }
                        }}
                        color="error"
                        name="isBOMEnabled"
                        inputProps={{ 'aria-label': 'bom toggle' }}
                      />}
                    label="Is BOM Required"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        checked={cutSkuEnabled}
                        onChange={(event) => {
                          setCutSkuEnabled(event.target.checked);
                          if (event.target.checked) {
                            setBomEnabled(false);
                            setBomRows([]);
                            setBomLineForm({ skuCode: '', quantity: '' });
                            setEditingBomSkuCode('');
                            setEditingBomRow(null);
                          }
                          setEditingBomSkuCode('');
                          setEditingBomRow(null);
                          if (!event.target.checked) {
                            setBomRows([]);
                            setBomLineForm({ skuCode: '', quantity: '' });
                          } else {
                            setBomLineForm({ skuCode: '', quantity: '' });
                          }
                        }}
                        color="error"
                        name="isCutSkuEnabled"
                        inputProps={{ 'aria-label': 'cut sku toggle' }}
                      />}
                    label="Is Cut SKU"
                  />
                </Stack>
                {(bomEnabled || cutSkuEnabled) ?
                  <>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
                      <Grid item md={3} xs={12} style={{ paddingBottom: '16px' }}>
                        {bomEnabled == true ?
                          <Autocomplete
                            size="small"
                            options={skuMasterList.filter((item) => item.isBOM == false)}
                            getOptionLabel={(option) => `${option.skuCode} - ${option.name}`}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Product Code *"
                                variant="outlined"
                                size="small"
                                error={!!bomLineErrors.skuCode}
                                helperText={bomLineErrors.skuCode || ''}
                                fullWidth
                              />
                            )}
                            value={skuMasterList.find((item) => item.skuCode === bomLineForm.skuCode) || null}
                            onChange={(event, newValue) => {
                              setBomLineForm((prev) => ({
                                ...prev,
                                skuCode: newValue ? newValue.skuCode : ''
                              }));
                              setBomLineErrors({ skuCode: '', name: '', uom: '', quantity: bomLineErrors.quantity || '' });
                            }}
                          /> : null}
                        {cutSkuEnabled == true ?
                          <Autocomplete
                            size="small"
                            options={skuMasterList.filter((item) => item.isCutSKU == false)}
                            getOptionLabel={(option) => `${option.skuCode} - ${option.name}`}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Product Code *"
                                variant="outlined"
                                size="small"
                                error={!!bomLineErrors.skuCode}
                                helperText={bomLineErrors.skuCode || ''}
                                fullWidth
                              />
                            )}
                            value={skuMasterList.find((item) => item.skuCode === bomLineForm.skuCode) || null}
                            onChange={(event, newValue) => {
                              setBomLineForm((prev) => ({
                                ...prev,
                                skuCode: newValue ? newValue.skuCode : ''
                              }));
                              setBomLineErrors({ skuCode: '', name: '', uom: '', quantity: bomLineErrors.quantity || '' });
                            }}
                          /> : null}
                      </Grid>

                      <Grid item md={3} xs={12}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Product Name *"
                          value={selectedBomSku ? selectedBomSku.name : ''}
                          InputProps={{ readOnly: true }}
                          error={!!bomLineErrors.name}
                          helperText={bomLineErrors.name || ''}
                        />
                      </Grid>
                      <Grid item md={2} xs={12}>
                        <TextField
                          fullWidth
                          size="small"
                          label="UOM *"
                          value={selectedBomSku ? selectedBomSku.uom : ''}
                          InputProps={{ readOnly: true }}
                          error={!!bomLineErrors.uom}
                          helperText={bomLineErrors.uom || ''}
                        />
                      </Grid>
                      {bomEnabled ?
                        <Grid item md={2} xs={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Quantity *"
                            name="quantity"
                            value={bomLineForm.quantity}
                            onChange={handleBomLineChange}
                            onKeyDown={(evt) => (evt.key === '-') && evt.preventDefault()}
                            InputProps={{
                              inputProps: {
                                step: 0.001,
                                min: 0,
                                type: 'number'
                              }
                            }}
                            onWheel={event => event.target.blur()}
                            error={!!bomLineErrors.quantity}
                            helperText={bomLineErrors.quantity || ''}
                          />
                        </Grid>
                        : null}

                      <Grid item md={bomEnabled ? 2 : 4} xs={12}>
                        <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '8px', alignItems: 'center' }}>
                          {(editingBomSkuCode !== '') ?
                            <Button variant="outlined" color='inherit' onClick={handleCancelBomEdit}>
                              Cancel
                            </Button>
                            : null}
                          <Button
                            variant="contained"
                            color='secondary'
                            onClick={handleAddBomLine}
                            disabled={cutSkuEnabled && bomRows.length > 0 && editingBomSkuCode === ''}
                          >
                            {cutSkuEnabled
                              ? (editingBomSkuCode !== '' ? 'Update' : 'Set Cut SKU')
                              : (editingBomSkuCode !== '' ? 'Update' : 'Add BOM')}
                          </Button>
                        </div>
                      </Grid>
                    </Stack>
                    {bomRows.length > 0 ?
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} style={{ marginTop: '12px' }}>
                        <TableContainer component={Paper}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>SKU Code</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>UOM</TableCell>
                                {bomEnabled ? <TableCell align="right">Quantity</TableCell> : null}
                                <TableCell align="center">Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {bomRows.map((row) => (
                                <TableRow key={row.tempId || row.skuCode}>
                                  <TableCell>{row.skuCode}</TableCell>
                                  <TableCell>{row.name}</TableCell>
                                  <TableCell>{row.uom}</TableCell>
                                  {bomEnabled ? <TableCell align="right">{row.quantity}</TableCell> : null}
                                  <TableCell align="center">
                                    <IconButton size="small" color="primary" onClick={() => handleEditBomLine(row)}>
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" style={{ color: 'red' }} onClick={() => requestRemoveBomLine(row)}>
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Stack>
                      : null}

                    <Dialog
                      open={deleteBomConfirm.open}
                      onClose={closeDeleteBomConfirm}
                      aria-labelledby="product-bom-delete-confirm-title"
                    >
                      <DialogTitle id="product-bom-delete-confirm-title">
                        {cutSkuEnabled ? 'Delete Cut SKU?' : 'Delete BOM line?'}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          Are you sure you want to delete {cutSkuEnabled ? 'this Cut SKU' : 'this BOM line'}
                          {deleteBomConfirm.row?.skuCode ? ` (${deleteBomConfirm.row.skuCode})` : ''}?
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={closeDeleteBomConfirm} color="inherit">
                          Cancel
                        </Button>
                        <Button onClick={confirmDeleteBomLine} color="error" variant="contained">
                          Delete
                        </Button>
                      </DialogActions>
                    </Dialog>

                    <Dialog
                      open={backConfirmOpen}
                      onClose={closeBackConfirm}
                      aria-labelledby="product-back-confirm-title"
                    >
                      <DialogTitle id="product-back-confirm-title">
                        Confirm navigation
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          Are you sure you want to go back? Any unsaved changes will be lost.
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={closeBackConfirm} color="inherit">
                          Stay
                        </Button>
                        <Button onClick={confirmBackNavigation} color="secondary" variant="contained">
                          Back
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </>
                  : null}
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Card sx={{ maxWidth: 345 }}>
                    <Card hidden={ImageHide}>
                      <CardMedia
                        component="img"
                        height="140"
                        image={`data:image/jpeg;base64,${ImageObject}`}
                        {...getFieldProps('image')}
                        error={Boolean(touched.image && errors.image)}
                        helperText={touched.image && errors.image}
                      />
                    </Card>
                    <ImageUploader
                      withIcon={false}
                      singleImage={true}
                      withPreview={true}
                      buttonText='Upload Your Image'
                      onChange={onDrop}
                      image={formik.values.image}
                      imgExtension={['.jpg', '.png']}
                      maxFileSize={5242880}
                    />
                  </Card>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        value={formik.values.isActive}
                        checked={formik.values.isActive}
                        {...getFieldProps('isActive')}
                        onClick={formik.handleChange}
                        color="error"
                        name="isActive"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />}
                    label="Is Active"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        value={formik.values.isSeasonal}
                        checked={formik.values.isSeasonal}
                        {...getFieldProps('isSeasonal')}
                        onClick={formik.handleChange}
                        color="error"
                        name="isSeasonal"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />}
                    label="Is Seasonal"
                  />
                </Stack>
                <Divider variant="middle" />
                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                  {pageProps.editingID == 0 ?
                    <LoadingButton
                      size="small"
                      type="button"
                      variant="outlined"
                      color='error'
                      onClick={() => clearAll()}
                    >
                      Clear
                    </LoadingButton>
                    : null}
                  <LoadingButton
                    size="small"
                    type="submit"
                    color='secondary'
                    variant="outlined"
                  >
                    {pageProps.submitButtonName}
                  </LoadingButton>
                </Stack>
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page >
    </>
  )
}